
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as codice_authenticatoronBNUNZ5nWK7rih2PDRI8JhDPLor0pwNJq4vbyGxua8Meta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/verifica_dispositivo/codice_authenticator.vue?macro=true";
import { default as codice_emailjjnWCucwNgEtJFqU9jTcnWNJoqSjR4LsF3umpzBDWM4Meta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/verifica_dispositivo/codice_email.vue?macro=true";
import { default as assistenzaYR7cSU_tQ_uaucwldTYJAR8jZwokg1l_MA41WSM2JEAMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/assistenza.vue?macro=true";
import { default as impostazioniImKJ5WLWuArpf_qVtjLKMZjYo_mhkd4ufpiU_szy_jQMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/impostazioni.vue?macro=true";
import { default as logincFDZdS5SvchHKxkphmpuuSz_5b4PaUOP6gAWRAqXCEMMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/login.vue?macro=true";
import { default as notifiche_TXnkz6KS7JtvVdd1ttqlnr9aaO13b43OhQ4ZHNe9OsMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/notifiche.vue?macro=true";
import { default as privacym3voktBXpS41IcGamBq_zFsQofi4WzomQVTFoDPqX_4Meta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/privacy.vue?macro=true";
import { default as profilosrzo2PDC8GB6MIWpFckyTxi__XxLmK6PLG9Z_HcGW8MMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/profilo.vue?macro=true";
import { default as recupera_45passwordrJCJn_NNDVChsRB1NZBexSZduBTV4tLdlp4KxMViRlIMeta } from "/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/recupera-password.vue?macro=true";
export default [
  {
    name: "anagrafiche-allarmi",
    path: "/anagrafiche/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/allarmi.vue")
  },
  {
    name: "anagrafiche-dispositivi",
    path: "/anagrafiche/dispositivi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/dispositivi.vue")
  },
  {
    name: "anagrafiche-firmware",
    path: "/anagrafiche/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/firmware.vue")
  },
  {
    name: "anagrafiche-impianti",
    path: "/anagrafiche/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/impianti.vue")
  },
  {
    name: "anagrafiche-modelli_inverters",
    path: "/anagrafiche/modelli_inverters",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/modelli_inverters.vue")
  },
  {
    name: "anagrafiche-utenti",
    path: "/anagrafiche/utenti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/utenti.vue")
  },
  {
    name: "anagrafiche-utenti_api",
    path: "/anagrafiche/utenti_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/anagrafiche/utenti_api.vue")
  },
  {
    name: "monitoraggio-firmware",
    path: "/monitoraggio/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/monitoraggio/firmware.vue")
  },
  {
    name: "monitoraggio-impianti",
    path: "/monitoraggio/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/monitoraggio/impianti.vue")
  },
  {
    name: "storico-allarmi",
    path: "/storico/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/allarmi.vue")
  },
  {
    name: "storico-batteria",
    path: "/storico/batteria",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/batteria.vue")
  },
  {
    name: "storico-comandi",
    path: "/storico/comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/comandi.vue")
  },
  {
    name: "storico-inclinazioni",
    path: "/storico/inclinazioni",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/inclinazioni.vue")
  },
  {
    name: "storico-meteo",
    path: "/storico/meteo",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/meteo.vue")
  },
  {
    name: "storico-produzione",
    path: "/storico/produzione",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/storico/produzione.vue")
  },
  {
    name: "strumenti-archivio",
    path: "/strumenti/archivio",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/archivio.vue")
  },
  {
    name: "strumenti-backup",
    path: "/strumenti/backup",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/backup.vue")
  },
  {
    name: "strumenti-database",
    path: "/strumenti/database",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/database.vue")
  },
  {
    name: "strumenti-log_api",
    path: "/strumenti/log_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/log_api.vue")
  },
  {
    name: "strumenti-log_attivita",
    path: "/strumenti/log_attivita",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/log_attivita.vue")
  },
  {
    name: "strumenti-log_comandi",
    path: "/strumenti/log_comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/log_comandi.vue")
  },
  {
    name: "strumenti-log_eventi",
    path: "/strumenti/log_eventi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/strumenti/log_eventi.vue")
  },
  {
    name: "verifica_dispositivo-codice_authenticator",
    path: "/verifica_dispositivo/codice_authenticator",
    meta: codice_authenticatoronBNUNZ5nWK7rih2PDRI8JhDPLor0pwNJq4vbyGxua8Meta || {},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/verifica_dispositivo/codice_authenticator.vue")
  },
  {
    name: "verifica_dispositivo-codice_email",
    path: "/verifica_dispositivo/codice_email",
    meta: codice_emailjjnWCucwNgEtJFqU9jTcnWNJoqSjR4LsF3umpzBDWM4Meta || {},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/verifica_dispositivo/codice_email.vue")
  },
  {
    name: "impianti-id",
    path: "/impianti/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/impianti/[id].vue")
  },
  {
    name: "assistenza",
    path: "/assistenza",
    meta: { ...(assistenzaYR7cSU_tQ_uaucwldTYJAR8jZwokg1l_MA41WSM2JEAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/assistenza.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/dashboard.vue")
  },
  {
    name: "impostazioni",
    path: "/impostazioni",
    meta: { ...(impostazioniImKJ5WLWuArpf_qVtjLKMZjYo_mhkd4ufpiU_szy_jQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/impostazioni.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(logincFDZdS5SvchHKxkphmpuuSz_5b4PaUOP6gAWRAqXCEMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/login.vue")
  },
  {
    name: "notifiche",
    path: "/notifiche",
    meta: { ...(notifiche_TXnkz6KS7JtvVdd1ttqlnr9aaO13b43OhQ4ZHNe9OsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/notifiche.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacym3voktBXpS41IcGamBq_zFsQofi4WzomQVTFoDPqX_4Meta || {},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/privacy.vue")
  },
  {
    name: "profilo",
    path: "/profilo",
    meta: profilosrzo2PDC8GB6MIWpFckyTxi__XxLmK6PLG9Z_HcGW8MMeta || {},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/profilo.vue")
  },
  {
    name: "recupera-password",
    path: "/recupera-password",
    meta: recupera_45passwordrJCJn_NNDVChsRB1NZBexSZduBTV4tLdlp4KxMViRlIMeta || {},
    component: () => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/pages/recupera-password.vue")
  }
]